import type { Meta, StoryObj } from "@storybook/react";

import type { SelectableCardProps } from "@/ui/core/SelectableCard";
import SelectableCard from "@/ui/core/SelectableCard";

const StoryMeta: Meta<SelectableCardProps> = {
  title: "Core/SelectableCard",
  component: SelectableCard,
  argTypes: {
    isSelected: { control: "boolean" },
    label: { control: "text" },
    onSelect: { action: "selected" },
    testID: { control: "text" },
  },
  args: {
    isSelected: false,
    label: "Sunday 5 - 6 PM",
    testID: "storybook",
  },
};

type Story = StoryObj<SelectableCardProps>;

const Primary: Story = {};

const Selected: Story = {
  args: {
    isSelected: true,
  },
};

export { Primary, Selected };
export default StoryMeta;
